import { NgModule } from '@angular/core';
import { LoginComponent } from './components/login/login.component';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from './services/guards/authentication.guard';
import { SdasComponent } from './components/sda/sdas/sdas.component';
import { SdaFormComponent } from './components/sda/sda-form/sda-form.component';
import { CdrsComponent } from './components/cdr/cdrs/cdrs.component';
import { SitesComponent } from './components/sites/sites/sites.component';
import { FunctionsComponent } from './components/functions/functions/functions.component';
import { SiteFormComponent } from './components/sites/site-form/site-form.component';
import { DevicesComponent } from './components/devices/devices/devices.component';
import { DeviceFormComponent } from './components/devices/device-form/device-form.component';
import { CalendarsComponent } from './components/calendars/calendars/calendars.component';
import { CalendarFormOldComponent } from './components/calendars/calendar-form-old/calendar-form-old.component';
import { ExtensionsComponent } from './components/extensions/extensions/extensions.component';
import { GlobalRulesComponent } from './components/globalRules/global-rules/global-rules.component';
import { GlobalRuleFormComponent } from './components/globalRules/global-rule-form/global-rule-form.component';
import { RestrictionsComponent } from './components/restrictions/restrictions/restrictions.component';
import { RestrictionFormComponent } from './components/restrictions/restriction-form/restriction-form.component';
import { ServicesComponent } from './components/services/services/services.component';
import { ServiceFormComponent } from './components/services/service-form/service-form.component';
import { ExtensionComponent } from './components/extensions/extension/extension.component';
import { ExtensionRuleComponent } from './components/extensions/extension-rule/extension-rule.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { InstanceComponent } from './components/instance/instance.component';
import { InstanceGuard } from './services/guards/instance.guard';
import { CalendarFormComponent } from './components/calendars/calendar-form/calendar-form.component';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'instance',
        component: InstanceComponent,
        canActivate: [AuthenticationGuard],
    },
    {
        path: 'sdas',
        component: SdasComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'sda',
        component: SdaFormComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'sites',
        component: SitesComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'site',
        component: SiteFormComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'services',
        component: ServicesComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'service',
        component: ServiceFormComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'devices',
        component: DevicesComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'device',
        component: DeviceFormComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'calendars',
        component: CalendarsComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'calendar',
        component: CalendarFormComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'extensions',
        component: ExtensionsComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'extension',
        component: ExtensionComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'globalrules',
        component: GlobalRulesComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'globalrule',
        component: GlobalRuleFormComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'restrictions',
        component: RestrictionsComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'restriction',
        component: RestrictionFormComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
    {
        path: 'extensionrule',
        component: ExtensionRuleComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
	{
		path: 'functions',
		component: FunctionsComponent,
		canActivate: [AuthenticationGuard, InstanceGuard],
	},
    {
        path: 'cdrs',
        component: CdrsComponent,
        canActivate: [AuthenticationGuard, InstanceGuard],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            preloadingStrategy: PreloadAllModules,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
